import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PMRulesGrid } from "./components/PMRulesGrid";
import RulesAddinData from "./models/RulesAddinData";
import combineRulesData from "./utils/combineRulesData";
import SearchField from "@/components/filter/SearchField";
import { FilterStackLayout } from "@/components/layout/FilterStackLayout";
import AddInIds from "@/constants/AddInIds";
import { useAddinData } from "@/hooks/addins/useAddinData";
import { useRulesByName } from "@/hooks/rules/useRulesByName";
import { useDebounced } from "@/hooks/useDebounced";

export default function PMRulesEditPage() {
  const [search, setSearch] = useState("");
  const searchDebounced = useDebounced(search, 300);
  const { t } = useTranslation();
  const { data: addinData = [] } = useAddinData<RulesAddinData>(AddInIds.pmrulesData);
  const { data: rulesData = [], isLoading: isRulesLoading } = useRulesByName([
    "[PM]%" + searchDebounced + "%",
    "[PM1]%" + searchDebounced + "%",
  ]);

  const data = combineRulesData(addinData, rulesData?.flat() ?? []);

  return (
    <FilterStackLayout
      filters={
        <>
          <SearchField
            value={search}
            setValue={setSearch}
            title={t("diagnosticEdit.ruleTitle")}
            placeholder={t("diagnosticEdit.ruleInptPlaceholder")}
          />
        </>
      }
      content={<PMRulesGrid isLoading={isRulesLoading} data={data} />}
    />
  );
}
